import Immutable from "seamless-immutable";
import initialState from "./initialState";
import {types} from "../actions/appSettingsActions";


export default function appSettingsReducer(state = Immutable(initialState.appSettings), action) {
  switch (action.type) {
    case types.GET_APP_SETTINGS:
      return state.merge({ fetching: true });
    case types.GET_APP_SETTINGS_SUCCESS:
      return state.merge({
        fetching: false,
        data: action.data,
      });
    case types.GET_APP_SETTINGS_FAILURE:
      return state.merge({ fetching: false});
    default:
      return state;
  }
}
